import { useMutation } from '@tanstack/react-query';

import { KYCService } from '@/features/kyc/services/KYCService';
import { DashboardHelpers } from '@/utils/DashboardHelpers';

import { TComputedKycDocument } from '@/features/kyc/store/models/kyc.model';

interface IUseKycDownloadDocumentProps {
  document: TComputedKycDocument;
}

export function useKycDownloadDocument({ document }: IUseKycDownloadDocumentProps) {
  const { isPending, mutate: triggerDownloadDocument } = useMutation({
    mutationFn: async (documentId: string) => await KYCService.getBaasPreviewKycDocument(documentId),
    onSuccess: (data) => DashboardHelpers.downloadFile(data.url, document.fileName || ``, true),
  });

  return {
    isPending,
    triggerDownloadDocument: () => triggerDownloadDocument(document.documentId),
  };
}
